module.exports = "<div class=\"form-container\">\n    <div class=\"form-nav\">\n        <a ui-sref=\"app.face.index.user.form.login\" class=\"nav-item\" ui-sref-active=\"active\">{{'face-form-text001' | translate}}</a>\n        &nbsp;&nbsp;|&nbsp;&nbsp;\n        <a ui-sref=\"app.face.index.user.form.register\" class=\"nav-item\" ui-sref-active=\"active\">{{'face-form-text002' | translate}}</a>\n    </div>\n    <div class=\"face-form\" ui-view></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/user/templates/form.html
// module id = 751
// module chunks = 3